import $ from 'jquery';
import axios from 'axios';
import toastr from 'toastr';
import { loader } from './../layout/loader'
import { datatablesArr } from './../components/datatables';
import { refreshTable } from './../components/datatables-helpers';
import Translator from 'bazinga-translator';


let popup;

function refreshDatatable() {

    refreshTable(datatablesArr['app_estimation_setting_rate_list']);

    $('#listing_table_app_estimation_setting_rate_list').find('.table__empty--nodata').removeClass('is-active');

}

class Popup {
    body: Object;
    element: Object;
    options: Object;
    templateOverlay: string;
    templatePopup: string;

    constructor(element: Object) {
        this.body = $('body');
        this.element = element;
        this.options = element.data('options');
        this.templateOverlay = '';
        this.templatePopup = '<div class="pop-up -esti-settings -sm"><div class="pop-up__background js-popup-close"></div></div>';
    }



    removePopupHtml() {
        $('.pop-up').remove();

        popup = null;
    }

    hidePopup() {
        $('.pop-up').removeClass('is-opened');
        setTimeout(() => {
            $('.overlay').removeClass('is-active');
        }, 300);

        setTimeout(() => {
            this.removePopupHtml();
        }, 500);
    }
    
    showPopup() {
        $('.overlay').addClass('is-opened');
        setTimeout(() => {
            $('.pop-up').addClass('is-opened');
        }, 200);
    }

    fetchContent() {

        $('.pop-up').append(

            '<div class="pop-up__box">' +
            '<form>' +

            '<div class="pop-up__content">' +
                '<h2>' + Translator.trans('edit_mode.modal.rate.create_new_header', [], 'app') + '</h2>' +
                '<label for="title">' + Translator.trans('edit_mode.modal.rate.title', [], 'app') + '</label>' +
                '<div class="input"><input type="text" id="title" placeholder="' + Translator.trans('edit_mode.modal.rate.title_placeholder', [], 'app') + '" value=""></div>' +
                '<div class="box-form__row -half">' +
                    '<div class="input">' +
                        '<label for="amount">' + Translator.trans('edit_mode.modal.rate.amount', [], 'app') + '</label>' +
                        '<div class="input__field"><input type="text" id="amount" placeholder="' + Translator.trans('edit_mode.modal.rate.amount_placeholder', [], 'app') + '" value=""></div>' +
                    '</div>' +
                    '<div class="input">' +
                        '<label for="unit">' + Translator.trans('edit_mode.modal.rate.unit', [], 'app') + '</label>' +
                        '<div class="input__field"><input type="text" id="unit" placeholder="' + Translator.trans('edit_mode.modal.rate.unit_placeholder', [], 'app') + '" value=""></div>' +
                    '</div>' +
                '</div>' +
                '<label for="currency">' + Translator.trans('edit_mode.modal.rate.currency', [], 'app') + '</label>' +
                '<div class="input"><input type="text" id="currency" placeholder="' + Translator.trans('edit_mode.modal.rate.currency_placeholder', [], 'app') + '" value=""></div>' +
            '</div>' +


            '<div class="pop-up__buttons">' +
            '<a class="btn-popup js-popup-close" href="#">' + Translator.trans('cancel', [], 'app') + '</a>' +
            '<button class="btn-popup -primary js-popup-settings-save" type="submit">' + Translator.trans('save', [], 'app') + '</button>' +
            '</div>' +
            '</form>' +
            '</div>'
        );

        $('.js-popup-settings-save').on('click', function(e) {
            e.preventDefault();
            popup.addNew();
        });

        this.showPopup();

    }

    fetchContentEdit() {
        const id = this.element.data('id');
        const path = Routing.generate('app_estimation_setting.rate.put', {"id": id});

        axios.get(path)
            .then(function(response){
                if (response.status === 200) {

                    $('.pop-up').append(

                        '<div class="pop-up__box"><form>' +
                            '<div class="pop-up__content">' +
                                '<h2>' + Translator.trans('edit_mode.modal.rate.edit_header', [], 'app') + '</h2>' +
                                '<label for="title">' + Translator.trans('edit_mode.modal.rate.title', [], 'app') + '</label>' +
                                '<div class="input"><input type="text" id="title" value="' + response.data.title + '"></div>' +
                                '<div class="box-form__row -half">' +
                                    '<div class="input">' +
                                        '<label for="amount">' + Translator.trans('edit_mode.modal.rate.amount', [], 'app') + '</label>' +
                                        '<div class="input__field"><input type="text" id="amount" value="' + response.data.rate + '"></div>' +
                                    '</div>' +
                                    '<div class="input">' +
                                        '<label for="unit">' + Translator.trans('edit_mode.modal.rate.unit', [], 'app') + '</label>' +
                                        '<div class="input__field"><input type="text" id="unit" value="' + response.data.unit + '"></div>' +
                                    '</div>' +
                                '</div>' +
                                '<label for="currency">' + Translator.trans('edit_mode.modal.rate.currency', [], 'app') + '</label>' +
                                '<div class="input"><input type="text" id="currency" value="' + response.data.currency + '"></div>' +
                            '</div>' +
                            '<div class="pop-up__buttons">' +
                                '<a class="btn-popup js-popup-close" href="#">' + Translator.trans('cancel', [], 'app') + '</a>' +
                                '<button class="btn-popup -primary js-popup-settings-save" type="submit">' + Translator.trans('save', [], 'app') + '</button>' +
                            '</div>' +
                        '</form></div>'
                    );

                    loader.hide();

                    $('.js-popup-settings-save').on('click', function(e) {
                        e.preventDefault();
                        popup.saveChanges();
                    })

                } else {
                    console.log('error');
                }

            }).then(
            this.showPopup()
        );

    }

    addNew() {
        const path = Routing.generate('app_estimation_setting.rate.post');

        const rate = {
            "currency": $('#currency').val(),
            "rate": $('#amount').val(),
            "title": $('#title').val(),
            "unit": $('#unit').val()
        };

        axios.post(path, rate)
            .then(function(res){
                if (res.status === 200) {
                    refreshDatatable();
                } else {
                    toastr.error(Translator.trans('notification_modals.save_rate_template.error_text', [], 'app'));
                }

            });

        loader.show();

        this.hidePopup()

    }

    saveChanges() {
        const id = this.element.data('id');
        const path = Routing.generate('app_estimation_setting.rate.put', {"id": id});

        const rate = {
            "currency": $('#currency').val(),
            "rate": $('#amount').val(),
            "title": $('#title').val(),
            "unit": $('#unit').val()
        };

        axios.put(path, rate)
            .then(function(res){
                if (res.status === 200) {
                    refreshDatatable();
                } else {
                    toastr.error(Translator.trans('notification_modals.save_rate_template.error_text', [], 'app'));
                }

            });

        loader.show();

        this.hidePopup()

    }

    appendPopupHtml(value) {
        this.body.append(this.templatePopup);
        this.body.append(this.templateOverlay);

        if (value === 'edit') {
            this.fetchContentEdit();
        } else {
            this.fetchContent();
        }

        $(document).on('click', '.js-popup-close', (e: Object) => {
            e.preventDefault();
            this.hidePopup();
        });
    }

    init(value) {
            this.appendPopupHtml(value);
    }
    
}

function init() {
    $(document).on('click', '.js-popup-settings-rate', function(e) {
        loader.show();
        popup = new Popup($(this));
        popup.init('edit');
        e.preventDefault();
    });

    $(document).on('click', '.js-popup-settings-rate-new', function(e) {
        popup = new Popup($(this));
        popup.init();
        e.preventDefault();
    });
}

export { init };




// WEBPACK FOOTER //
// ./src/_app/estimation-settings/rates.js